/*
 * whatsapp-optin.js: behaviour for snippets/whatsapp-optin-card.liquid.
 * Loaded from layout/theme.liquid on every page, not inline in the snippet:
 * the mini-cart drawer is fetched via the Section Rendering API and inserted
 * with innerHTML, so an inline <script> in it never executes (the tick box did
 * nothing on every page except /cart). All handlers are delegated on document,
 * so cards rendered later are covered.
 */
(function () {
  if (window.__skylitWaOptin) return;
  window.__skylitWaOptin = true;

  var timers = new WeakMap();

  // What the customer typed is saved as-is; skylit-admin turns it into an
  // international number on orders/paid (normalizeWaPhone in app/lib/whatsapp.ts),
  // reading a number without +/00 in the order's shipping-country format. So
  // here only reject what cannot be a phone: + / 00 numbers need 10-15 digits
  // with the country code, a national number 8-15 digits.
  var HELP = 'Outside the UK? Start with your country code, e.g. +353.';

  function digits(v) {
    var s = String(v || '').replace(/\(0\)/g, '');
    var plus = s.charAt(0) === '+';
    var d = s.replace(/\D/g, '');
    if (!d) return '';
    if (plus || d.indexOf('00') === 0) {
      if (!plus) d = d.slice(2);
      return d.length >= 10 && d.length <= 15 ? d : '';
    }
    return d.length >= 8 && d.length <= 15 ? d : '';
  }

  function setHint(card, text, cls) {
    var h = card.querySelector('[data-wa-optin-hint]');
    if (!h) return;
    h.textContent = text || HELP;
    h.className = 'wa-optin__hint' + (text && cls ? ' ' + cls : '');
  }

  function sync(value) {
    var url = (window.theme && window.theme.routes && window.theme.routes.cart_update_url) || '/cart/update.js';
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ attributes: { _whatsapp_phone: value } })
    }).then(function (r) { return r.ok; }).catch(function () { return false; });
  }

  // Mirror the value into every other copy of the card (drawer + page).
  function mirror(from, value, on) {
    document.querySelectorAll('[data-wa-optin]').forEach(function (card) {
      if (card === from) return;
      var t = card.querySelector('[data-wa-optin-toggle]');
      var p = card.querySelector('[data-wa-optin-phone]');
      var w = card.querySelector('[data-wa-optin-phone-wrap]');
      if (t) t.checked = on;
      if (w) w.hidden = !on;
      if (p) { p.disabled = !on; if (p.value !== value) p.value = value; }
      card.classList.toggle('is-on', on);
    });
  }

  function onToggle(card, toggle) {
    var wrap = card.querySelector('[data-wa-optin-phone-wrap]');
    var phone = card.querySelector('[data-wa-optin-phone]');
    var on = toggle.checked;
    card.classList.toggle('is-on', on);
    if (wrap) wrap.hidden = !on;
    if (phone) phone.disabled = !on;
    if (on) {
      if (phone) phone.focus();
      setHint(card, '', '');
      if (phone && digits(phone.value)) sync(phone.value.trim());
    } else {
      setHint(card, '', '');
      sync('');
      mirror(card, '', false);
    }
  }

  function onPhone(card, phone) {
    clearTimeout(timers.get(card));
    timers.set(card, setTimeout(function () {
      var raw = phone.value.trim();
      if (!raw) { setHint(card, '', ''); sync(''); mirror(card, '', true); return; }
      if (!digits(raw)) { setHint(card, 'Check the number. Outside the UK, start with your country code, e.g. +353.', 'is-error'); return; }
      sync(raw).then(function (ok) {
        setHint(card, ok ? 'We’ll message this number.' : 'Could not save just now, try again.', ok ? 'is-ok' : 'is-error');
        if (ok) mirror(card, raw, true);
      });
    }, 500));
  }

  document.addEventListener('change', function (e) {
    var toggle = e.target.closest && e.target.closest('[data-wa-optin-toggle]');
    if (!toggle) return;
    var card = toggle.closest('[data-wa-optin]');
    if (card) onToggle(card, toggle);
  });

  document.addEventListener('click', function (e) {
    var more = e.target.closest && e.target.closest('[data-wa-optin-more]');
    if (more) {
      var card = more.closest('[data-wa-optin]');
      var dlg = card && card.querySelector('[data-wa-optin-dialog]');
      if (dlg && typeof dlg.showModal === 'function') { e.preventDefault(); dlg.showModal(); }
      return;
    }
    var close = e.target.closest && e.target.closest('[data-wa-optin-close]');
    if (close) { var d = close.closest('dialog'); if (d) d.close(); return; }
    // Click on the backdrop (outside the inner panel) closes too.
    if (e.target && e.target.matches && e.target.matches('dialog[data-wa-optin-dialog]')) e.target.close();
  });

  document.addEventListener('input', function (e) {
    var phone = e.target.closest && e.target.closest('[data-wa-optin-phone]');
    if (!phone) return;
    var card = phone.closest('[data-wa-optin]');
    if (card) onPhone(card, phone);
  });
})();
